module.exports = __webpack_public_path__ + "img/law1m.1b3102b8.webp";